export const blogFeed = () => {

	let blogFeedModules = document.querySelectorAll('.m__blog-feed');
	if(blogFeedModules){
		blogFeedModules.forEach((module) => {

			//Get category & calendar filters for this module
			let categoryFilters = module.querySelectorAll('.js__cat-filter');

			//Get the event card container
			let cardContainer = module.querySelector('.js__cards');

			//Get the data storage element
			let moduleData = module.querySelector('.js__data');

			if(categoryFilters.length > 0){
				categoryFilters.forEach((catFilter) => {
					catFilter.addEventListener('click',(e) => {
						if(!e.target.classList.contains('active')){ //Do nothing if the clicking the current active month
							
							//Save the filter change
							moduleData.dataset.cat = e.target.dataset.cat;
							
							//Change the highlighted option on the front end
							categoryFilters.forEach((catFilter) => {
								catFilter.classList.remove('active');
							});
							e.target.classList.add('active');
							
							let queryData = new FormData;

							queryData.append('action','ajaxGetBlogPosts');
							queryData.append('filters',moduleData.dataset.cat);

							fetch(igniteAjax.ajaxurl, {
								method: 'POST',
								body: queryData,
							})
							.then((response) => response.text())
							.then((data) => {
								cardContainer.innerHTML = data;
							})
							.catch((error) => {
								cardContainer.innerHTML = '<p class="font-title text-grey text-3xl">An error occured, please refresh the page</p>';
								console.error(error);
							});
						}
					})
				})
			}


		})
	}

}